// @ts-nocheck
import { Box, Divider, Modal, Typography, useMediaQuery } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import styles from "../../contractors/calendar/_components/shiftcalendar.module.css";
import pStyles from "./prebook.module.css";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as Yup from "yup";
import { phoneNumberFormat } from "../../../utils/methods/formatters";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import theme from "../../../theme";
import { useFormik } from "formik";

// NOTE: style for modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 4,
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  minWidth: "780px",
  zIndex: 9,
  maxHeight: "80vh",
  overflowY: "auto",
  "@media (max-width: 780px)": {
    minWidth: "400px",
    maxHeight: "90vh",
  },
};

export const ViewPreBookModal = ({ open, handleClose, data }) => {
  const validationSchema = Yup.object({
    contractorsList: Yup.array()
      .of(Yup.object())
      .min(1, "At least 1 contractor should be selected"),
    comment: Yup.string()
      .max(400, "Comment should be at most 400 characters!")
      .required("Comment is required!"),
    selectedDates: Yup.array()
      .of(Yup.string())
      .min(1, "At least one date should be selected"),
    startDate: Yup.string()
      .nullable()
      .trim()
      .test(
        "time-should-be-greater-than-today",
        "Start date cannot be a past date!",
        function (value) {
          return !value || !dayjs(value).isBefore(dayjs(), "day");
        },
      ),
    endDate: Yup.string()
      .nullable()
      .trim()
      .test(
        "end-date-should-be-greater-than-start-date",
        "End date can not be before start date!",
        function () {
          return (
            !this.parent.endDate ||
            !dayjs(this.parent.endDate).isBefore(this.parent.startDate, "day")
          );
        },
      ),
    selectDateRange: Yup.bool(),
  });

  const formik = useFormik({
    initialValues: {
      selectedDates: [],
      selectDateRange: false,
      startDate: null,
      endDate: null,
      comment: "",
      contractorsList: [],
    },
    validationSchema,
    onSubmit: () => {},
  });

  const { values, setFieldValue } = formik;

  const getDefaultClassName = getDefaultClassNames();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  useEffect(() => {
    setFieldValue("selectedDates", data?.selectedDates);
  }, [data]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "1rem",
          }}
          className="custom-scroll-bar"
        >
          <Box className={styles.headingContainer}>
            <Typography className={styles.heading}>
              Pre Booking Details
            </Typography>
          </Box>
          <Box className={styles["calendar-parent"]}>
            <DayPicker
              mode="multiple"
              classNames={{
                month: `${getDefaultClassName.month} ${styles.month}`,
                selected: `${getDefaultClassName.selected} ${styles.selected}`,
                chevron: `${getDefaultClassName.chevron} ${styles.chevron}`,
              }}
              required={true}
              selected={values?.selectedDates?.map((date) =>
                dayjs(date).toDate(),
              )}
              onSelect={() => {}}
            />
            {/* NOTE: at right there we'll be the selected dates */}
            <Box
              sx={{
                maxHeight: "385px",
                overflowY: "auto",
                overflowX: "hidden",
                "&::-webkit-scrollbar": {
                  width: "8px !important",
                },
              }}
              className="custom-scroll-bar"
            >
              {values?.selectedDates?.length > 0 && (
                <Box className={styles["selected-dates-container"]}>
                  <Typography fontWeight={600}>Selected Dates</Typography>
                  <Typography></Typography>
                  {values?.selectedDates?.map((date, i) => {
                    const dateString = dayjs(date).format("ddd MM/DD/YYYY");
                    return (
                      <Box className={styles["one-date"]} key={i}>
                        <Typography className={"no-wrap"}>
                          {dateString}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
          </Box>

          {/* NOTE: comment */}
          {/* <Box */}
          {/*   sx={{ */}
          {/*     display: "flex", */}
          {/*     width: "100%", */}
          {/*     px: isSmallScreen ? "1rem" : "2rem", */}
          {/*   }} */}
          {/* > */}
          {/*   <Box */}
          {/*     sx={{ */}
          {/*       border: "1px solid white", */}
          {/*       borderRadius: "8px", */}
          {/*       width: "100%", */}
          {/*       padding: "0.25rem 0.5rem", */}
          {/*     }} */}
          {/*   > */}
          {/*     <Typography>{data?.comment}</Typography> */}
          {/*   </Box> */}
          {/* </Box> */}

          {/* NOTE: show the list of contractors */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              px: isSmallScreen ? "1rem" : "2rem",
            }}
          >
            <Typography
              sx={{ textAlign: "left", width: "100%", marginBottom: "0.5rem" }}
            >
              Contractors
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
              }}
            >
              {data?.contractors?.map((option, i) => {
                return (
                  <Box key={i} className={pStyles["options-parent-container"]}>
                    <Box className={pStyles["option-container"]}>
                      <Typography color={theme.palette.green.main}>
                        Name:&nbsp;
                        <Typography
                          sx={{
                            display: "inline",
                            color: getCssVariableHandler({
                              variableName: "--font-rgb",
                            }),
                          }}
                        >
                          {`${option?.firstName} ${option?.lastName}`}
                        </Typography>
                      </Typography>
                      <Divider
                        sx={{
                          backgroundColor: getCssVariableHandler({
                            variableName: "--font-rgb",
                          }),
                        }}
                      />

                      <Box className={pStyles["phone-and-email-container"]}>
                        <Typography color={theme.palette.green.main}>
                          Phone:&nbsp;
                          <Typography
                            sx={{
                              display: "inline",
                              color: getCssVariableHandler({
                                variableName: "--font-rgb",
                              }),
                            }}
                          >
                            {phoneNumberFormat(option?.mobile)}
                          </Typography>
                        </Typography>
                        <Typography color={theme.palette.green.main}>
                          Email:&nbsp;
                          <Typography
                            sx={{
                              display: "inline",
                              color: getCssVariableHandler({
                                variableName: "--font-rgb",
                              }),
                            }}
                          >
                            {option?.email}
                          </Typography>
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Box>
      </Modal>
    </LocalizationProvider>
  );
};

ViewPreBookModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  data: PropTypes.object,
};